import { fromJS, Map } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'
import { LOAD_PLANS } from '../PlanSelection/constants'

const initialState = fromJS({})

function reducer(state = initialState, action) {
  let newState = state

  switch (action.type) {
    case actionTypes.ADD_DATASET:
      return state
        .delete('addDatasetError')
        .delete('newDatasetId')
        .set('addingDataset', true)
    case actionTypes.ADD_DATASET_ERROR:
      return state
        .set('addDatasetError', action.error)
        .set('addingDataset', false)
    case actionTypes.ADD_DATASET_DONE:
      return state
        .set('addDatasetStatus', null)
        .set('addingDataset', false)
        .set('newDatasetId', action.datasetId)
    case actionTypes.UPDATE_ADD_DATASET_STATUS:
      return state.set('addDatasetStatus', action.status)
    case actionTypes.CLEAR_DATASET_ERROR:
      return state.delete('addDatasetError')

    case actionTypes.LIST_DATASETS:
      return state.set('listDatasets', true)
    case LOAD_PLANS:
    case actionTypes.CLEAR_DATASETS:
      return state.set('datasets', new Map())
    case actionTypes.LIST_DATASETS_DONE:
      return state
        .set('listDatasets', false)
        .setIn(['datasets', action.page], action.datasets)
    case actionTypes.LIST_DATASETS_ERROR:
      return state
        .set('listDatasets', false)
        .set('listDatasetsError', action.error)

    case actionTypes.UPDATE_DATASET:
      return state.set('updatingDataset', true)
    case actionTypes.UPDATE_DATASET_DONE:
      if (typeof action.page !== 'undefined') {
        const existingDatasets = newState.getIn(['datasets', action.page])
        const datasetIndexToUpdateInExistingDatasets =
          existingDatasets.content.findIndex(
            (dataset) => dataset.id === action.dataset.id
          )
        existingDatasets.content[datasetIndexToUpdateInExistingDatasets] = {
          ...existingDatasets.content[datasetIndexToUpdateInExistingDatasets],
          ...action.dataset
        }

        newState = newState.setIn(['datasets', action.page], existingDatasets)
      }

      return newState.set('updatingDataset', false)
    case actionTypes.UPDATE_DATASET_ERROR:
      return state
        .set('updateDatasetError', action.error)
        .set('updatingDataset', false)
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
